export const statsCounterSchema = {
  title: 'Stats Counter',
  fieldsets: [
    {
      id: 'default',
      title: 'Stat 1',
      fields: ['stat1_label', 'stat1_portal_type', 'stat1_description'],
    },
    {
      id: 'stat2',
      title: 'Stat 2',
      fields: ['stat2_label', 'stat2_portal_type', 'stat2_description'],
    },
    {
      id: 'stat3',
      title: 'Stat 3',
      fields: ['stat3_label', 'stat3_portal_type', 'stat3_description'],
    },
  ],
  properties: {
    stat1_label: {
      title: 'Label',
      type: 'string',
      default: 'People',
    },
    stat1_portal_type: {
      title: 'Portal Type',
      description: 'Plone content type ID, e.g. people',
      type: 'string',
      default: 'people',
    },
    stat1_description: {
      title: 'Description',
      description: 'Short text shown below the number',
      type: 'string',
      default: 'researchers & staff',
    },
    stat2_label: {
      title: 'Label',
      type: 'string',
      default: 'Projects',
    },
    stat2_portal_type: {
      title: 'Portal Type',
      description: 'Plone content type ID, e.g. Project',
      type: 'string',
      default: 'project',
    },
    stat2_description: {
      title: 'Description',
      description: 'Short text shown below the number',
      type: 'string',
      default: 'active research projects',
    },
    stat3_label: {
      title: 'Label',
      type: 'string',
      default: 'Publications',
    },
    stat3_portal_type: {
      title: 'Portal Type',
      description: 'Plone content type ID, e.g. Publication',
      type: 'string',
      default: 'publication',
    },
    stat3_description: {
      title: 'Description',
      description: 'Short text shown below the number',
      type: 'string',
      default: 'peer-reviewed publications',
    },
  },
  required: [],
};
